import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import type { Informacion } from '../api';

export default function Header({ info, conInfobar = false }: { info: Informacion | null; conInfobar?: boolean }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuAbierto, setMenuAbierto] = useState(false);
  const { count, openCart } = useCart();
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => { setMenuAbierto(false); }, [location.pathname]);
  const whatsapp = info?.whatsapp || '';
  const links = [
    { to: '/', label: 'Inicio' },
    { to: '/menu', label: 'Menú' },
    { to: '/nosotros', label: 'Nosotros' },
    { to: '/contacto', label: 'Contacto' },
  ];
  return (
    <header
      className={`fixed left-0 right-0 z-40 transition-all duration-300 ${conInfobar ? 'top-9' : 'top-0'} ${scrolled ? 'bg-wine-darker/95 backdrop-blur-md shadow-lg py-3' : 'py-5'}`}
    >
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img src="/logo.png" alt="Soda Celes" className="h-12 w-auto drop-shadow-lg" />
          <div className="leading-none">
            <span className="block text-gold italic font-semibold text-sm font-display">Soda</span>
            <span className="block text-white font-display font-extrabold text-2xl -mt-1">Celes</span>
          </div>
        </Link>
        <nav className="hidden md:flex gap-9">
          {links.map(l => (
            <Link key={l.to} to={l.to}
              className="text-white font-medium text-sm tracking-wide hover:text-gold transition-colors">
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <button onClick={openCart} className="relative w-10 h-10 rounded-xl bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors">
            🛒
            {count > 0 && (
              <span className="absolute -top-1.5 -right-1.5 bg-accent text-white text-[11px] font-bold w-5 h-5 rounded-full flex items-center justify-center">
                {count}
              </span>
            )}
          </button>
          {whatsapp && (
            <a href={`https://wa.me/${whatsapp}`} target="_blank" rel="noreferrer"
              className="hidden md:flex items-center gap-2 bg-gold hover:bg-gold-light text-wine-darker font-bold text-sm px-5 py-2.5 rounded-full transition-transform hover:-translate-y-0.5">
              💬 Pedir por WhatsApp
            </a>
          )}
          <button className="md:hidden text-white text-2xl" onClick={() => setMenuAbierto(!menuAbierto)}>
            {menuAbierto ? '✕' : '☰'}
          </button>
        </div>
      </div>
      {menuAbierto && (
        <div className="md:hidden bg-wine-darker/98 backdrop-blur-md mt-4 py-4">
          <nav className="flex flex-col items-center gap-5">
            {links.map(l => (
              <Link key={l.to} to={l.to} className="text-white font-medium text-base">{l.label}</Link>
            ))}
            {whatsapp && (
              <a href={`https://wa.me/${whatsapp}`} target="_blank" rel="noreferrer"
                className="bg-gold text-wine-darker font-bold text-sm px-6 py-2.5 rounded-full">
                💬 Pedir por WhatsApp
              </a>
            )}
          </nav>
        </div>
      )}
    </header>
  );
}
